<section class="panel">
  <h3>Incompletion By Course</h3>
  <div class="chart-list">
    @if (loading) {
        <div class="chart-row course-skeleton">
          <app-loading-skeleton [count]="1" width="80%" height="10px" borderRadius="4px"></app-loading-skeleton>
          <app-loading-skeleton [count]="1" width="100%" height="10px" borderRadius="999px"></app-loading-skeleton>
          <app-loading-skeleton [count]="1" width="32px" height="10px" borderRadius="4px"></app-loading-skeleton>
        </div>
    } @else if (courseRows.length > 0) {
      @for (row of courseRows; track row.course) {
        <div class="chart-row">
          <span class="name">{{ row.course }}</span>
          <div class="bar-track">
            <div
              class="bar-fill"
              [style.width.%]="row.incomplete_percentage"
              [class.risk-high]="row.incomplete_percentage > 60"
              [class.risk-mid]="row.incomplete_percentage > 40 && row.incomplete_percentage <= 60"
            ></div>
          </div>
          <span class="pct">{{ row.incomplete_percentage }}%</span>
        </div>
      }
    } @else {
      <div class="chart-row-error">
        <span class="name">No course data</span>
      </div>
    }
  </div>

</section>
